/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PropertiesInputs */

const cs_nav_properties = /** @type {(inputs: Nav_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti`)
};

const en_nav_properties = /** @type {(inputs: Nav_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties`)
};

/**
* | output |
* | --- |
* | "Properties" |
*
* @param {Nav_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_properties = /** @type {((inputs?: Nav_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_properties(inputs)
	return cs_nav_properties(inputs)
});